
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M33.485 16.515a1.5 1.5 0 010 2.121L27.121 25l6.364 6.364a1.5 1.5 0 01-2.121 2.121L25 27.121l-6.364 6.364a1.5 1.5 0 01-2.121-2.121L22.879 25l-6.364-6.364a1.5 1.5 0 012.121-2.121L25 22.879l6.364-6.364a1.5 1.5 0 012.121 0z","fill":"#979797"}}),_c('path',{attrs:{"stroke":"#979797","d":"M.5.5h49v49H.5z"}})])])
          )
        }
      }
    